const read = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
	
		reader.onload = () => resolve(reader.result); 		
		reader.onerror = () => reject( reader.error );
		
		reader.readAsArrayBuffer(file);    
	});	
}


class BrowserFileReader {

	constructor(file) {
		this.file = file;
	} 
	
	read(start, end) {
		let source = this.file;
		if( start !== undefined && end !== undefined ) {
			source = this.file.slice( start, end );		
		}
	
		const result = read( source );
		return result;	
	}
	
	get name() {	
		return this.file.name;
	}
	
	get blob() {
		return this.file;
	}	
}

const file_reader = (file) => new BrowserFileReader(file);

export {
	file_reader
}
